import { On3IconOn3HighSchool } from '@on3/icons';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { MobileMPU } from 'components/Ads/MobileMPU';
import { MPU } from 'components/Ads/MPU';
import { CoverList } from 'components/Headlines/ArticleCover/CoverList';
import { FeedList } from 'components/Headlines/ArticleFeed/FeedList';
import { StateRankings } from 'components/HighSchool/Modules/StateRankings/StateRankings';
import { TopRankings } from 'components/HighSchool/Modules/TopRankings/TopRankings';
import { SEOHomeText } from 'components/Home/SEOHomeText';
import { HomeLayout } from 'components/Layouts/HomeLayout';
import { type HighSchoolHomePageProps } from 'pages/high-school';

import styles from './HighSchoolHome.module.scss';

const highSchoolViewAll = [
  {
    url: 'high-school/news/',
    text: 'View All High School News',
    title: 'High School News',
  },
];

export const HighSchoolHome = ({
  latestArticles,
  topRankings,
  states,
}: HighSchoolHomePageProps) => {
  const coverArticles = latestArticles?.slice(0, 3);
  const { currentSite } = useSite();
  const siteColor = currentSite?.primaryColor || '#fe3b1f';

  return (
    <>
      {!!coverArticles?.length && (
        <CoverList backgroundColor={siteColor} list={coverArticles} />
      )}
      <SEOHomeText>
        <On3IconOn3HighSchool className={styles.metaIcon} />
        <h1>
          Leader in High School News, Scores, Schedules, Rankings, Recruiting
          and Data.
        </h1>
      </SEOHomeText>
      <HomeLayout>
        <section className={styles.feed}>
          <div className={styles.inner}>
            {/* Player Search goes here */}
            {!latestArticles?.length || (
              <FeedList
                list={latestArticles.slice(3, 12)}
                section="High School News"
                viewAllLinks={highSchoolViewAll}
              />
            )}
            <MobileMPU id={'mobile_mpu_top'} incontent />
          </div>
        </section>
        <aside className={styles.sidebarright}>
          <div className={styles.inner}>
            <MPU id={'mpu_top'} />
            {topRankings && <TopRankings rankings={topRankings} />}
            <MPU id={'mpu_middle'} />
            <MobileMPU id={'mobile_mpu_middle'} incontent />
          </div>
        </aside>
        <aside className={styles.sidebarleft}>
          <div className={styles.inner}>
            {states && <StateRankings states={states} />}
          </div>
        </aside>
      </HomeLayout>
    </>
  );
};
